import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 8px;
    font-family: "averta", sans-serif;

    @media (min-width: 1440px) {
      font-size: 10px;
    }
  }

  body {
    margin: 0px;
    font-size: 1.6rem;
  }

  html, body, #root {
  }

  p, h1, h2, h3, h4, h5, h6 {
    padding: 0px;
    margin: 0px;
    line-height: 2rem;
  }

  h4 {
    font-size: 1.8rem;
  }

  h6 {
    font-size: 1.8rem;
  }

  p {
    font-size: 1.6rem;
    color: #4B4B4B;
    line-height: 25px;
  }

  input, select {  
    font-size: 1.6rem;
  }

  a {
    text-decoration: none;
    color: #096DD9;
    font-size: 1.6rem;
    font-weight: 500;
  }

  p + p {
    margin-top: 0px !important;
  }

@font-face {
  font-family: "averta";
  src: url("../assets/fonts/Averta/Averta-Regular.otf") format(".otf");
  font-weight: normal;
  font-style: normal;
}
`;